// Shared v-autosize directive: grow a <textarea> to fit its content — on insert
// (initial load), on input, and whenever its bound value changes programmatically
// (e.g. switching agent). Reused across the admin dashboard's editors.
function fit (el) {
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

export default {
  inserted (el) {
    el.__fit = () => fit(el)
    el.addEventListener('input', el.__fit)
    // Fit after the browser has laid the textarea out (scrollHeight is 0 too early).
    el.__fit()
    requestAnimationFrame(el.__fit)
  },
  componentUpdated (el) {
    fit(el)
  },
  unbind (el) {
    if (el.__fit) el.removeEventListener('input', el.__fit)
  }
}
